var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntegrations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.76465 0.769531C0.79815 0.769531 0.0146484 1.55303 0.0146484 2.51953V8.01617V8.76617V8.76818V9.51818V15.0148C0.0146484 15.9813 0.798151 16.7648 1.76465 16.7648H7.26395H8.01329H8.01395H8.76329H14.2626C15.2291 16.7648 16.0126 15.9813 16.0126 15.0148V9.51818V8.76818V8.76617V8.01617V2.51953C16.0126 1.55303 15.2291 0.769531 14.2626 0.769531H8.76329H8.01395H8.01329H7.26395H1.76465ZM14.5126 8.01617V2.51953C14.5126 2.38146 14.4007 2.26953 14.2626 2.26953H8.76395V8.01617H14.5126ZM8.76395 9.51818H14.5126V15.0148C14.5126 15.1529 14.4007 15.2648 14.2626 15.2648H8.76395V9.51818ZM1.51465 8.01617H7.26329V2.26953H1.76465C1.62658 2.26953 1.51465 2.38146 1.51465 2.51953V8.01617ZM1.51465 15.0148V9.51818H7.26329V15.2648H1.76465C1.62658 15.2648 1.51465 15.1529 1.51465 15.0148Z",
    fill: "#8E97A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrations);
export default __webpack_public_path__ + "static/media/Integrations.e5e80ab0dd3d9d616faa3f585ac076fc.svg";
export { ForwardRef as ReactComponent };